import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import React from 'react'
import { CustomCol, FormLabels, CustomDatePicker } from 'src/components'

const BrokerageCreatedAtField: React.FC = () => {
  const { t } = useTranslation()

  return <Row>
    <CustomCol>
      <FormLabels
        title={t('admin.Brokerage.OperationDate')}
        subtitle={t('general.Optional')}
      />
    </CustomCol>
    <CustomCol>
      <CustomDatePicker
        name={'createdAt'}
        placeholder={t('admin.CertificateDatePlaceholder')}
      />
    </CustomCol>
  </Row>
}

export default BrokerageCreatedAtField
